import { Layer } from "../core/layer";

export class LayerFactory {
    constructor(LayerCtor = Layer) {
        this.LayerCtor = LayerCtor;
    }
    create({stage: stage, global: global, window: window, params: params}) {
        return new this.LayerCtor(stage, global, window, params);
    }
}
//# sourceMappingURL=layer-factory.js.map
